import script from "./SchoolInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolInfo.vue?vue&type=script&setup=true&lang=js"

import "./SchoolInfo.vue?vue&type=style&index=0&id=4ecf535a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecf535a"]])

export default __exports__